import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { MatTableDataSource, MatDialog, PageEvent, MatPaginator } from '@angular/material';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ComponentPageTitle } from 'src/app/page-title/page-title.component';
import { AppServiceService } from 'src/app/services/app-service.service';
import { BusquedaService } from '../busqueda.service';
import { CreateService } from '../createservice';
import { CrudAgenteComponent } from './crud-agente/crud-agente.component';
import { AsignarCampanaComponent } from '../asignar-campana/asignar-campana.component';
import { GatewayService } from 'src/app/gateway.service';
import { ConfirmacionComponent } from '../confirmacion/confirmacion.component';
import { FiltroPaisService } from '../filtro-pais.service';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { MatSnackBar } from '@angular/material';
import { ReasignacionModalComponent } from '../agente/reasignacion-modal/reasignacion-modal.component';

@Component({
  selector: 'app-admin-agente',
  templateUrl: './admin-agente.component.html',
  styleUrls: ['./admin-agente.component.scss']
})
export class AdminAgenteComponent implements OnInit {
  private destroy$ = new Subject<void>();
  usuariosCant = 5;
  //campanaColumns: string[] = ['IDAGENTE', 'NOMBRE', 'GENERO', 'CORREO', 'TELEFONO', 'PROFESION', 'PAIS', 'ACCION'];
  // campanaColumns: string[] = ['NOMBRE', 'ROL', 'CORREO', 'TELEFONO', 'PROFESION', 'PAIS', 'ACCION'];
  //campanaColumns: string[] = ['NOMBRE', 'ROL', 'CORREO', 'TELEFONO', 'PROFESION', 'ACCION'];
  // campanaColumns: string[] = ['NOMBRE', 'ROL', 'CORREO', 'TELEFONO', 'PROFESION', 'ESTADO', 'ACCION'];
  // campanaColumns: string[] = ['NOMBRE', 'ROL', 'CORREO', 'TELEFONO', 'CONTRATA', 'ESTADO', 'ACCION'];
  campanaColumns: string[] = ['IDAGENTE','NOMBRE', 'ROL', 'CORREO', 'TELEFONO', 'CONTRATA', 'DISP_AM', 'DISP_PM', 'ESTADO', 'ACCION'];
  dataSource = new MatTableDataSource<any>([]);
  private subscription: Subscription;
  private subscriptioncreate: Subscription;
  private subscriptionpais: Subscription;
  FILTER; resultsLength = 0;
  pageSize = 10;
  idpais;
  pageEvent: PageEvent
  public actpage: number = 0;
  @ViewChild('paginatoragente') paginatoragente: MatPaginator;
  constructor(
    private router: Router,
    private spinner: NgxSpinnerService,
    private gateway: GatewayService,
    public pageTitle: ComponentPageTitle,
    public _appservice: AppServiceService,
    public _busqueda: BusquedaService,
    public _create: CreateService,
    private dialog: MatDialog,
    public _filtroPais: FiltroPaisService,
    private localSave: LocalSaveService,
    private snackbar: MatSnackBar

  ) { }

  ngOnInit() {
    const user = this.localSave.get('usuarioPGV');
    if (!user || user.idrol != 16) {
      this.router.navigate(['/home']);
    }
    this.idpais = this.localSave.get('pais');
    this.get(0);
    this.pageTitle.title = 'Agentes';
    // this.loadUsuarios();
    this.subscription = this._busqueda.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
      res => {
        this.filtrarAgente(res.filtro);
      });
    this.subscriptioncreate = this._create.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
      res => {
        this.createAgente();
      });
    this.subscriptionpais = this._filtroPais.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
      res => {
        this.idpais = res.IDPAIS;
        this.get(0);
      }
    );
  }

  // ============== FILTRO ==============
  filter = '';
  public keyDownFunction(event) {
    if (event.keyCode == 13) {
      this.filtrogeneral();
    } else if (event.keyCode == 8 && this.filter == '') {
      this.filtrogeneral();
    }
  }
  public filtrogeneral() {
    this._busqueda.notificarBusqueda({ filtro: this.filter });
  }

  get(page) {
    this.spinner.show();
    this.gateway.get('getadminagente', { NUM_PAGINA: page, FILTRO: this.FILTER, NUM_ELEMENTOS: this.pageSize, IDPAIS: this.idpais, IDDISTRIBUIDOR: this.localSave.get('usuarioPGV').IDU, IDPADRE: this.localSave.get('usuarioPGV').IDU, IDAREA: this.localSave.get('usuarioPGV').IDAREA }).then((result) => {
      let aux: any = result;
      this.dataSource = aux.rows;
      //this.resultsLength = 3//;result[1][0].TOTAL;
      this.gateway.get('getadminagentecount', { NUM_PAGINA: page, FILTRO: this.FILTER, NUM_ELEMENTOS: this.pageSize, IDPAIS: this.idpais, IDDISTRIBUIDOR: this.localSave.get('usuarioPGV').IDU, IDPADRE: this.localSave.get('usuarioPGV').IDU, IDAREA: this.localSave.get('usuarioPGV').IDAREA }).then((result: any) => {
        this.resultsLength = result.rows[0].total;
        this.spinner.hide();
      });
    }
    ).catch(function (e) {
    });
  }

  cambioElementos(event?: PageEvent) {
    this.actpage = event.pageIndex;
    this.get(event.pageIndex);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.subscription.unsubscribe();
    this.subscriptioncreate.unsubscribe();
    this.subscriptionpais.unsubscribe();
  }

  createAgente() {
    const dialogRef = this.dialog.open(CrudAgenteComponent, {
      maxWidth: '150vw',
			width: '970px',
      minHeight: '50vh',
      data: { operacion: 'Crear', agente: { idpais: this.idpais } },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      this.get(this.actpage);
    });
  }

  filtrarAgente(data) {
    this.FILTER = data;
    this.get(0)
  }

  edit(element) {
    //element.idpais = this.idpais;
    const dialogRef = this.dialog.open(CrudAgenteComponent, {
      maxWidth: '150vw',
			width: '970px',
      minHeight: '50vh',
      data: { operacion: 'Editar', agente: element },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.get(this.actpage);
      }
    });
  }

  delete(element) {
    const dialogRef = this.dialog.open(ConfirmacionComponent, {
      disableClose: true,
      width: '450px',
      data: { operacion: 'deleteagente', id: { ID: element.idagente }, msj: 'deshabilitar el agente', snackb: 'Deshabilitado con éxito' }
    });

    dialogRef.afterClosed().subscribe(() => {
      this.paginatoragente.firstPage();
      this.get(0);
    });
  }

  habilitar(element, idestado) {

    const mensajes = [
			'deshabilitar al agente',   // Índice 0: deshabilitar
			'habilitar al agente',     // Índice 1: habilitar
			'poner al agente en vacaciones', // Índice 2: vacaciones
			'marcar al agente como incapacitado', // Índice 3: incapacitado
			'enviar al agente a capacitación',    // Índice 4: capacitación
		];

		let component: any = ConfirmacionComponent;
		let styles: any = {
			width: "450px",
		};

		const reasignacionIndexes = [0, 2, 3, 4];

		if (reasignacionIndexes.includes(idestado)) {
			component = ReasignacionModalComponent;
			styles = {};
		}

    const dialogRef = this.dialog.open(component, {
      disableClose: true,
			...styles,
      data: {
        operacion: 'habilitaragente',
        id: {
          ID: element.idagente,
          idestado: idestado,
          iddistribuidor: element.iddistribuidor,
        }, msj: mensajes[idestado],
        snackb: 'Se realizó el cambio de estado con éxito',
      }
    });

    dialogRef.afterClosed().subscribe(() => {
      this.paginatoragente.firstPage();
      this.get(0);
    });
  }

  asignar(element) {
    element.IDPAIS = this.idpais;
    const dialogRef = this.dialog.open(AsignarCampanaComponent, {
      maxWidth: '120vw',
      width: '820px',
      minHeight: '40vh',
      data: { operacion: 'Editar', agente: element },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  //----------------------CARGA MASIVO-------------------

  cargaMasivo() {
    document.getElementById("uploadfile").click();
  }

  onFileChange(evt: any) {
    let LISTA = [];

    this.spinner.show();

    let uploadname = evt.target.value.split('\\')[evt.target.value.split('\\').length - 1];

    /*    this.openclose=false;*/
    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
      /* save data */
      const dataexcel: any = XLSX.utils.sheet_to_json(ws, { header: 1 });
      (<HTMLInputElement>document.getElementById('uploadfile')).value = null;
      // console.log(dataexcel);
      let csv = [];
      let flag = dataexcel[0];
      const bandera: number = 0;

      //validar columnas

      if (flag[0] === 'NOMBRE' && flag[1] === 'APELLIDO' && flag[2] === 'ROL' && flag[3] === 'GENERO'
        && flag[4] === 'NACIMIENTO' && flag[5] === 'USUARIO' && flag[6] === 'PASSWORD' && flag[7] === 'TELEFONO'
        && flag[8] === 'PROFESION' && flag[9] === 'CORREO') {
        dataexcel.forEach((value) => {
          if (value[0] != 'NOMBRE' && value[1] != 'APELLIDO' && value[2] != 'ROL' && value[3] != 'GENERO'
            && value[4] != 'NACIMIENTO' && value[5] != 'USUARIO' && value[6] != 'PASSWORD' && value[7] != 'TELEFONO'
            && value[8] != 'PROFESION' && value[9] != 'CORREO'
            && value[0] != '' && value[1] != '' && value[2] != '' && value[3] != ''
            && value[4] != '' && value[5] != '' && value[6] != '' && value[7] != ''
            && value[8] != ''
            && value[0] != undefined && value[1] != undefined && value[2] != undefined && value[3] != undefined
            && value[4] != undefined && value[5] != undefined && value[6] != undefined && value[7] != undefined
            && value[8] != undefined) {
            LISTA.push({ NOMBRE: value[0], APELLIDO: value[1], ROL: value[2], GENERO: value[3], NACIMIENTO: value[4], USUARIO: value[5], PASSWORD: value[6], TELEFONO: value[7], PROFESION: value[8], CORREO: value[9] });
          }
        });
        //  console.log(LISTA);
        this.loadlistxls(LISTA, 0);
      } else {
        this.snackbar.open('Formato de archivo no válido, porfavor intente con otro archivo.', 'CERRAR', { duration: 6000 });
        this.spinner.hide();
      }
      //this.spinner.hide();
    };
    reader.readAsBinaryString(target.files[0]);
  }

  loadlistxls(LISTA, cantidad) {
    this.spinner.show();
    let auxarr = [];
    auxarr = LISTA.slice(cantidad, cantidad + 300);
    this.gateway.save('cargamasivaagentes', { IDCAMPANA: 10, LISTA: auxarr, IDDISTRIBUIDOR: this.localSave.get('usuarioPGV').IDU, IDPADRE: this.localSave.get('usuarioPGV').IDU, IDAREA: this.localSave.get('usuarioPGV').IDAREA }).then(
      res => {
        const resultado: any = res;
        if ((cantidad + 300) < LISTA.length) {
          this.loadlistxls(LISTA, cantidad + 300);
        } else {
          this.spinner.hide();
          this.snackbar.open('Agentes creados con éxito: ' + resultado.EXITO + ', duplicados no cargados: ' + resultado.DUPLICADO, 'Cerrar', { duration: 3000, });
          this.get(this.actpage);
        }
      },
      err => {
        this.spinner.hide();
        this.snackbar.open('Los agentes no han sido cargados, intente nuevamente.', 'Cerrar', { duration: 3000, });
        // console.log(err);
      }
    );
  }

  //-----------------ELIMINA MASIVO----------------------
  eliminaMasivo() {
    document.getElementById("uploadfiledelete").click();
  }

  onFileChangeDelete(evt: any) {
    let LISTA = [];

    this.spinner.show();

    let uploadname = evt.target.value.split('\\')[evt.target.value.split('\\').length - 1];

    // console.log(uploadname);

    /*    this.openclose=false;*/
    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
      /* save data */
      const dataexcel: any = XLSX.utils.sheet_to_json(ws, { header: 1 });
      (<HTMLInputElement>document.getElementById('uploadfiledelete')).value = null;
      // console.log(dataexcel);
      let csv = [];
      let flag = dataexcel[0];
      const bandera: number = 0;

      //validar columnas

      if (flag[0] === 'USUARIO' && flag[1] === 'COMENTARIO') {
        dataexcel.forEach((value) => {
          if (value[0] != 'USUARIO' && value[0] != '' && value[0] != undefined
            && value[1] != 'COMENTARIO' && value[1] != '' && value[1] != undefined) {
            LISTA.push({ USUARIO: value[0], COMENTARIO: value[1] });
          }
        });
        this.loadlistxlsElimina(LISTA, 0);
      } else {
        this.snackbar.open('Formato de archivo no válido, porfavor intente con otro archivo.', 'CERRAR', { duration: 6000 });
        this.spinner.hide();
      }
    };
    reader.readAsBinaryString(target.files[0]);
  }

  loadlistxlsElimina(LISTA, cantidad) {
    this.spinner.show();
    let auxarr = [];
    auxarr = LISTA.slice(cantidad, cantidad + 300);
    this.gateway.save('eliminamasivaagentes', { IDCAMPANA: 10, LISTA: auxarr, IDDISTRIBUIDOR: this.localSave.get('usuarioPGV').IDU, IDPADRE: this.localSave.get('usuarioPGV').IDU, IDAREA: this.localSave.get('usuarioPGV').IDAREA }).then(
      res => {
        const resultado: any = res;
        if ((cantidad + 300) < LISTA.length) {
          this.loadlistxlsElimina(LISTA, cantidad + 300);
        } else {
          this.spinner.hide();
          this.snackbar.open('Agentes eliminados con éxito.', 'Cerrar', { duration: 3000, });
          this.get(this.actpage);
        }
      },
      err => {
        this.spinner.hide();
        this.snackbar.open('Los agentes no han sido eliminados, intente nuevamente.', 'Cerrar', { duration: 3000, });
        // console.log(err);
      }
    );
  }

  //----------------ASIGNA MASIVO------------------

  asignaMasivo() {
    document.getElementById("uploadfileasigna").click();
  }

  onFileChangeAsigna(evt: any) {
    let LISTA = [];

    this.spinner.show();

    let uploadname = evt.target.value.split('\\')[evt.target.value.split('\\').length - 1];

    // console.log(uploadname);

    /*    this.openclose=false;*/
    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
      /* save data */
      const dataexcel: any = XLSX.utils.sheet_to_json(ws, { header: 1 });
      (<HTMLInputElement>document.getElementById('uploadfileasigna')).value = null;
      // console.log(dataexcel);
      let csv = [];
      const flag = dataexcel[0];
      const bandera: number = 0;

      //validar columnas

      if (flag[0] === 'USUARIO' && flag[1] === 'CAMPAÑA' && flag[2] === 'CONTACTO' && flag[3] === 'EFECTIVIDAD'
        && flag[4] === 'CONVERSION' && flag[5] === 'TMO(SEG)' && flag[6] === 'LLAMADAS' && flag[7] === 'CONTACTOS EFECTIVOS') {
        dataexcel.forEach((value) => {
          if (value[0] != 'USUARIO' && value[0] != '' && value[0] != undefined
            && value[1] != 'CAMPAÑA' && value[1] != '' && value[1] != undefined
            && value[2] != 'CONTACTO' && value[2] != '' && value[2] != undefined
            && value[3] != 'EFECTIVIDAD' && value[3] != '' && value[3] != undefined
            && value[4] != 'CONVERSION' && value[4] != '' && value[4] != undefined
            && value[5] != 'TMO(SEG)' && value[5] != '' && value[5] != undefined
            && value[6] != 'LLAMADAS' && value[6] != '' && value[6] != undefined
            && value[7] != 'CONTACTOS EFECTIVOS' && value[7] != '' && value[7] != undefined) {
            LISTA.push({
              USUARIO: value[0], CAMPANA: value[1], CONTACTO: value[2], EFECTIVIDAD: value[3]
              , CONVERSION: value[4], TMO: value[5], LLAMADAS: value[6], CONTACTOS: value[7]
            });
          }
        });
        this.loadlistxlsAsigna(LISTA, 0);
      } else {
        this.snackbar.open('Formato de archivo no válido, porfavor intente con otro archivo.', 'CERRAR', { duration: 6000 });
        this.spinner.hide();
      }
    };
    reader.readAsBinaryString(target.files[0]);
  }

  loadlistxlsAsigna(LISTA, cantidad) {
    this.spinner.show();
    let auxarr = [];
    auxarr = LISTA.slice(cantidad, cantidad + 300);
    this.gateway.save('asignamasivaagentes', { IDCAMPANA: 10, LISTA: auxarr, IDDISTRIBUIDOR: this.localSave.get('usuarioPGV').IDU, IDPADRE: this.localSave.get('usuarioPGV').IDU, IDAREA: this.localSave.get('usuarioPGV').IDAREA }).then(
      res => {
        const resultado: any = res;
        if ((cantidad + 300) < LISTA.length) {
          this.loadlistxlsAsigna(LISTA, cantidad + 300);
        } else {
          this.spinner.hide();
          this.snackbar.open('Campañas asignadas con éxito: ' + resultado.agregados + ', campañas no asignadas: ' + resultado.noagregados, 'Cerrar', { duration: 5000, });
          this.get(this.actpage);
        }
      },
      err => {
        this.spinner.hide();
        this.snackbar.open('Los agentes no han sido asignados, intente nuevamente.', 'Cerrar', { duration: 5000, });
        // console.log(err);
      }
    );
  }

}

const CAMPANA_DATA: any[] = [
  // { IDEJE: 1, NOMBREEJE: 'AGENTE 1', DESCRIPCION: 'CORREO 1' },
  // { IDEJE: 2, NOMBREEJE: 'AGENTE 2', DESCRIPCION: 'CORREO 2' },
  // { IDEJE: 3, NOMBREEJE: 'AGENTE 3', DESCRIPCION: 'CORREO 3' },
  // { IDEJE: 4, NOMBREEJE: 'AGENTE 4', DESCRIPCION: 'CORREO 4' },
  // { IDEJE: 5, NOMBREEJE: 'AGENTE 5', DESCRIPCION: 'CORREO 5' },
  // { IDEJE: 6, NOMBREEJE: 'AGENTE 6', DESCRIPCION: 'CORREO 6' },
];